import { Theme } from '@mui/material'

const useStyles = {
  outerContainer: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginTop: '32px',
    marginBottom: '104px',
  },
  selectionRow: {
    paddingY: '8px',
    marginTop: '16px',
    gap: '8px',
    alignItems: 'center',
  },
  checkboxLabel: {
    flexDirection: 'column',
    paddingRight: '4px',
  },
  checkboxAddressRow: {
    alignItems: 'center',
  },
  footerRow: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  bulkCheckboxButton: (theme: Theme) => ({
    textTransform: 'none',
    minWidth: 'unset',
    padding: 0,
    paddingX: theme.spacing(1),
  }),
  submitButton: {
    width: '200px',
  },
  locationIcon: {
    fontSize: '16px',
  },
  checkboxContainer: (theme: Theme) => ({
    padding: 0,
    margin: 0,
    paddingTop: '12px',
    paddingBottom: '16px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    width: '100%',
    justifyContent: 'space-between',
    marginLeft: 0,
  }),
  footer: (theme: Theme) => ({
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    height: '104px',
  }),
}

export default useStyles
